import { fromClass } from "fw-model";
import { SearchResult } from "./search-result";

export class CommonAppTransferSearchResult extends SearchResult<CommonAppSdsTransferHistoryInfo> {}

export class CommonAppSdsTransferHistoryMetaData {
    DateCreatedUtc: Date;
    DateUpdatedUtc: Date;
}

export enum CommonAppSdsTransferStatus {
    Success = 0,
    Failed = 1,
    ConnectionError = 2
}

export class CommonAppSdsTransferHistory {
    Id: string;
    AtsOrganizationId: string;
    FileName: string;
    ApplicationCount: number;
    DocumentCount: number;
    SdsUser: string;
    FileDateUtc: Date;
    CommonAppYear: number;
    Status: CommonAppSdsTransferStatus;
    StatusMessage: string;
    @fromClass MetaData: CommonAppSdsTransferHistoryMetaData;
}

export class CommonAppSdsTransferHistoryInfo {
    OrganizationName: string;
    @fromClass History: CommonAppSdsTransferHistory;
}

export type CommonAppTransferFilter = {
    commonAppYear?: number;
    organization?: string;
    status?: number;
    range?: string | [];
};
